import React from "react";

const FitToPageHorizontal = () => (
  <svg width={21} height={10}>
    <path
      d="M4.721 7.397V5.333h11.554v2.062c0 .53.625.804 1.003.438l3.486-3.353a.606.606 0 000-.959L17.278.167c-.378-.364-1.003-.091-1.003.438v2.062H4.721V.603c0-.528-.623-.8-1-.436L.235 3.523a.603.603 0 000 .956l3.486 3.354c.377.366 1 .092 1-.436"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
);

export default FitToPageHorizontal;
